import { faFile, faFileContract, faFileUser, faMemo } from '@fortawesome/pro-solid-svg-icons'

import { InternshipFileTypes } from '../../../utils/entities/internshipRequestFile'
import FilesUploader from '../../../Components/antd/Uploaders/FilesUploader'
import FormItem from '../../../Components/shared/Forms/FormItem'

import '../../../assets/internship-request-files-form.scss'

const { RESUME, COVER_LETTER, CONVENTION, OTHER } = InternshipFileTypes

export const DEFAULT_DATA = { [RESUME]: [], [COVER_LETTER]: [], [CONVENTION]: [], [OTHER]: [] }

const FILE_FIELDS = [
  { type: RESUME, icon: faFileUser, label: 'form.label.cv' },
  { type: COVER_LETTER, icon: faMemo, label: 'form.label.motivation_letter' },
  { type: CONVENTION, icon: faFileContract, label: 'form.label.convention' },
  { type: OTHER, icon: faFile, label: 'form.label.other_files' }
]

const InternshipRequestFilesForm = ({ errorFields = [], files = DEFAULT_DATA, requiredFields = {}, setFiles }) => {
  const handleUpload = key => file => {
    setFiles({ ...files, [key]: [...files[key], file] })
  }
  const handleRemove = key => file => {
    setFiles({ ...files, [key]: files[key].filter(f => f.uid !== file.uid) })
  }

  const getClassName = field => (errorFields.includes(field) ? 'error-ant-border' : '')

  return (
    <div className='internship-request-files'>
      {FILE_FIELDS.map(({ type, icon, label }) => (
        <FormItem
          key={type}
          className={getClassName(type)}
          icon={icon}
          label={label}
          required={requiredFields[type]}
        >
          <FilesUploader
            files={files[type]}
            onUpload={handleUpload(type)}
            onRemove={handleRemove(type)}
          />
        </FormItem>
      ))}
    </div>
  )
}

export default InternshipRequestFilesForm
